import { Icon, enums as e, toast, utils as u } from 'edrolo-ui';
import { Button, ButtonProps } from 'edrolo-ui/components/Button';
import { useAnalytics } from 'edrolo/analytics';
import { useState } from 'react';
import { useShortLink } from './useShortLink';

interface ShortLinkProps {
  id: number;
  appLabel: string;
  model: string;
  queryString: string;
}

type CopyLinkButtonProps = Omit<ButtonProps, 'children'>;

interface CopyLinkProps {
  className?: string;
  buttonProps: CopyLinkButtonProps;
  shortLinkProps: ShortLinkProps;
  hideText?: boolean;
}

export const CopyLinkButton = ({
  buttonProps,
  shortLinkProps,
  hideText = false,
}: CopyLinkProps) => {
  const { data: shortLink, error, isLoading } = useShortLink(shortLinkProps);
  const { track } = useAnalytics({});
  const [copied, setCopied] = useState(false);

  const handleClick = () => {
    track('Share Link Copied', {
      'original_content_type_name': shortLinkProps.model,
      'original_object_id': shortLinkProps.id,
      'object_id': shortLinkProps.id,
    });

    try {
      navigator.clipboard
        .writeText(shortLink)
        .then(() => {
          setCopied(true);
          setTimeout(() => {
            setCopied(false);
          }, 4000);
        })
        .catch((err) => {
          toast({
            icon: {
              name: e.Icons.INFO_TIP,
              size: e.Size.LARGE,
              color: e.ColorHue.RED,
            },
            title: 'Clipboard write failed',
            description: `Please copy the link manually. ${shortLink}`,
          });
        });
    } catch (err) {
      toast({
        icon: {
          name: e.Icons.INFO_TIP,
          size: e.Size.LARGE,
          color: e.ColorHue.RED,
        },
        title: 'Clipboard access failed',
        description: `Please copy the link manually. ${shortLink}`,
      });
    }
  };

  return (
    <Button
      onClick={handleClick}
      disabled={error || isLoading}
      {...buttonProps}
    >
      {copied ? (
        <>
          <Icon className={!hideText && u.mr2} name={e.Icons.SUCCESS} />
          {!hideText && 'Copied!'}
        </>
      ) : (
        <>
          <Icon className={!hideText && u.mr2} name={e.Icons.COPY} />
          {!hideText && 'Copy Link'}
        </>
      )}
    </Button>
  );
};
